import { Component, OnInit, Input, Output, EventEmitter, HostBinding } from '@angular/core';
import { LayoutService } from '../layout.service';
import { Location } from '@angular/common';
import { Router, ActivatedRoute, NavigationEnd, NavigationStart } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { NavigationService } from '../navigation.service';
import { ApiService } from '../api.service';
import { Meta } from '@angular/platform-browser';
import { find } from 'lodash';

@Component({
  selector: 'app-page',
  templateUrl: './page.component.html',
  styleUrls: ['./page.component.scss']
})
export class PageComponent implements OnInit {
  @Input() template_type: string;
  @HostBinding('style.overflow') get overflow() { return this.LayoutService.overflow; };
  url;
  apiData;
  navigationStartSubscription;
  navigationEndSubscription;
  isLoadingApiData = false;

  constructor(
    private LayoutService: LayoutService,
    private location: Location,
    private router: Router,
    private route: ActivatedRoute,
    private apiService: ApiService,
    private NavigationService: NavigationService,
    private metaService: Meta
  ) {
    this.navigationStartSubscription = router.events.filter(event => event instanceof NavigationStart)
      .subscribe((val) => {
        this.template_type = null;
      });

    this.navigationEndSubscription = router.events.filter(event => event instanceof NavigationEnd)
      .subscribe((val) => {
        let categorySlug = this.route.parent.snapshot.params.category;
        let pageSlug = this.route.parent.snapshot.params.page;
        let pageId = this.route.parent.snapshot.queryParams.id;
        let url;

        if (typeof pageId !== 'undefined') {
          url = `pages/${pageId}`
        } else {
          // If is three column page (route is directly defined for slug)
          if (typeof categorySlug === 'undefined') {
            if (typeof this.route.parent.snapshot.params.section !== 'undefined') {
              pageSlug = /^\/([^\/]+)/.exec(window.location.pathname)[1];
            }
          }
          url = `pages/get_by_slug/${pageSlug}`;
        }

        if (this.url !== url) {
          this.isLoadingApiData = true;
          this.url = url;

          this.apiService.getData(url)
          .then((data) => {
            let page;
            this.isLoadingApiData = false;

            if (data['pages'].length > 1) {
              let categoryItem: any = find(window['categories'], { slug: categorySlug });
              page = find(data['pages'], { 'parent_id': categoryItem.id });
            } else {
              page = data['pages'][0];
            }

            if (typeof page === 'undefined' || page.is_disabled) {
              this.router.navigate(['/']);
            }

            // Change to pretty url if /pageid?id={id} url
            if (typeof pageId !== 'undefined') {
              let category: any = find(window['categories'], { id: page.parent_id });
              let newUrl;
              if (page.page_type === 'project') {
                newUrl = typeof categorySlug !== 'undefined' ? `${category.slug}/${pageSlug}/${page.slug}` : `${category.slug}/all/${page.slug}`;
              } else {
                newUrl = `${category.slug}/${page.slug}`;
              }
              this.router.navigateByUrl(newUrl, { replaceUrl: true });
            }

            this.apiData = page;

            const prevPageType = this.NavigationService.pageType;
            this.NavigationService.pageType = this.apiData.page_type;

            // Prev page not thumb, project, home or index
            if (typeof prevPageType === 'undefined') {
              this.NavigationService.projectSource = null;
              this.NavigationService.projectThumbs = [];
            // Thumb to project page
            } else if (prevPageType === 'thumbs' && this.NavigationService.pageType === 'project') {
              this.NavigationService.projectSource = 'thumbs';
            // Home to project page
            } else if (prevPageType === 'home' && this.NavigationService.pageType === 'project') {
              this.NavigationService.projectSource = 'home';
              this.NavigationService.projectThumbs = [];
            // Index to project page
            } else if (prevPageType === 'index' && this.NavigationService.pageType === 'project') {
              this.NavigationService.projectSource = 'index';
              this.NavigationService.projectThumbs = [];
            }

            this.NavigationService.setTitleAndMetaDescription(this.apiData, this.route.parent.snapshot.data['title']);
            this.metaService.updateTag({ name: 'keywords', content: this.apiData.meta_tags });
            this.metaService.updateTag({ name: 'description', content: this.apiData.meta_description });
          })
          .catch((error) => {
            console.log(error);
            // this.router.navigate(['/']);
          });
        }

      });
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    this.navigationStartSubscription.unsubscribe();
    this.navigationEndSubscription.unsubscribe();
  }
}


// WEBPACK FOOTER //
// ./src/app/page/page.component.ts